import React, { PropsWithChildren, useState } from "react"
import { CircularProgress, Grid2 } from "@mui/material"

import { Dialog } from "@/components/Dialog"

type ActionDialogProps = PropsWithChildren<{
	title: string
	open: boolean
	shouldHaveFullWidth?: boolean
	maxWidthSize?: "xs" | "sm" | "md" | "lg" | "xl"
	onClose: () => void
	onSave: () => Promise<void> | void
	cancelButtonLabel: string
	saveButtonLabel: string
}>

export const ActionDialog = (props: ActionDialogProps) => {
	const {
		onClose,
		onSave,
		cancelButtonLabel,
		saveButtonLabel,
		title,
		maxWidthSize,
		shouldHaveFullWidth,
		open,
		children
	} = props

	const [isSaving, setIsSaving] = useState<boolean>(false)

	const shouldConfirmButtonDisabled = isSaving

	const handleSave = async () => {
		setIsSaving(true)

		await onSave()

		setIsSaving(false)
	}

	const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault()

		handleSave()
	}

	return (
		<Dialog.Container
			onClose={onClose}
			open={open}
			fullWidth={shouldHaveFullWidth}
			maxWidth={maxWidthSize}
		>
			<form onSubmit={handleSubmit} style={{ width: "100%" }}>
				<Grid2 container spacing={2}>
					<Dialog.Header>
						<Dialog.Title>{title}</Dialog.Title>
						<Dialog.CloseIconButton onClick={onClose} />
					</Dialog.Header>
					<Dialog.Content>
						{children}
					</Dialog.Content>
					<Dialog.Footer>
						<Dialog.CancelButton
							onClick={onClose}
						>
							{cancelButtonLabel}
						</Dialog.CancelButton>
						<Dialog.ConfirmButton
							onClick={handleSave}
							disabled={shouldConfirmButtonDisabled}
							startIcon={isSaving && <CircularProgress size={20} />}
						>
							{saveButtonLabel}
						</Dialog.ConfirmButton>
					</Dialog.Footer>
				</Grid2>
			</form>
		</Dialog.Container>
	)
}